export const SaleTypeMap: Record<string, string> = {
  "0": "BSPAir",
  "1": "Supplier",
  "2": "Voucher",
  "3": "CommVoucher",
};